import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f1aa210e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1aa210e')) {
      api.createRecord('f1aa210e', component.options)
    } else {
      api.reload('f1aa210e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f1aa210e&", function () {
      api.rerender('f1aa210e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sdGy5OYha0fb/JS/comp/ImgFallback.vue"
export default component.exports